import React, { useRef, useEffect } from 'react';
import styles from './Box.module.css';
import ScrollReveal from 'scrollreveal';
import { Player } from '@lordicon/react';
const IconBox = ({ 
  icon, 

  shape = 'rectangle', // 'rectangle' or 'cube'
  text ="",
  iconPosition = 'left' // 'right', 'left', 'top', 'bottom', 'center'
}) => {
  const playerRef1 = useRef(null);

  const handleComplete = () => {
    setTimeout(() => {
      playerRef1?.current?.playFromBeginning();
    }, 2500);
  };

  useEffect(() => {
    playerRef1?.current?.playFromBeginning();
  }, []);

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.icon}`, {
      duration: 1000,
      distance: "30px",
      origin: "left",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });

    ScrollReveal().reveal(`.${styles.text}`, {
      duration: 1000,
      distance: "50px",
      origin: "right",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      delay: 400,
      scale: 1,
    });
  }, []);

  return (
    <div className={`${styles.container} ${styles[shape]} ${styles[`layout-${iconPosition}`]}`}>
      <div className={styles.glassOverlay}></div>
      
      <div className={styles.content}>
        <div className={styles.icon}>
          <Player 
            icon={icon} 
            ref={playerRef1} 
            size="100%" 
            colorize='black'
            onComplete={handleComplete}
          />
        </div>

        {text && (
          <div className={styles.text}>
            <p>{text}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default IconBox;